import React from 'react'
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube, FaLinkedin } from "react-icons/fa";

const Footer = () => {
const { siteConfig } = useSiteConfig();

  return (
    <>
      <footer id="footer" className="custom-footer">
      <Container fluid className="px-md-5 px-3">
        <div className="footer-grid">
          {/* Column 1: Brand/About + Socials */}
          <div className="footer-col footer-col-brand">
            <Link to="/" className="custom-footer-logo d-flex align-items-center mb-3">
              <img src={siteConfig?.logo} alt="logo" className="logo" />
            </Link>
            <p className="footer-text">
              {siteConfig?.footerDescription ||
                "We are passionate about providing high vibrational products that support your journey, wellness and transformation."}
            </p>
            <ul className="tf-social-icon">
              {siteConfig?.socialMedia?.facebook && (
                <li>
                  <a href={siteConfig.facebook} target="_blank" rel="noreferrer" className="social-icon-link">
                    <FaFacebook size={15} />
                  </a>
                </li>
              )}
              {siteConfig?.socialMedia?.instagram && (
                <li>
                  <a href={siteConfig.instagram} target="_blank" rel="noreferrer" className="social-icon-link">
                    <FaInstagram size={15} />
                  </a>
                </li>
              )}
              {siteConfig?.twitter && (
                <li>
                  <a href={siteConfig.twitter} target="_blank" rel="noreferrer" className="social-icon-link">
                    <FaTwitter size={15} />
                  </a>
                </li>
              )}
              {siteConfig?.youtube && (
                <li>
                  <a href={siteConfig.youtube} target="_blank" rel="noreferrer" className="social-icon-link">
                    <FaYoutube size={15} />
                  </a>
                </li>
              )}
              {siteConfig?.linkedin && (
                <li>
                  <a href={siteConfig.linkedin} target="_blank" rel="noreferrer" className="social-icon-link">
                    <FaLinkedin size={15} />
                  </a>
                </li>
              )}
            </ul>
          </div>

          {/* Column 2: Quick Links */}
          <div className="footer-col">
            <h5 className="footer-heading">Quick Links</h5>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about-us">About Us</Link></li>
              {/* <li><Link to="/shop">Shop</Link></li> */}
              {/* <li><Link to="/blog">Blogs</Link></li> */}
              <li><Link to="/contact-us">Contact Us</Link></li>
            </ul>
          </div>

          {/* Column 3: Help & Support */}
          <div className="footer-col">
            <h5 className="footer-heading">Help &amp; Support</h5>
            <ul className="footer-links">
              <li><Link to="/terms-and-conditions">Terms and Conditions</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              {/* <li><Link to="/return-and-refund-policy">Return and Refund Policy</Link></li> */}
            </ul>
          </div>

          {/* Column 4: Themed Quote Box */}
          <div className="footer-col">
            <div className="footer-quote-box">
              <svg
                className="footer-quote-icon"
                width="26"
                height="26"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 3C9.5 5 8 8 8 11.5C8 16.5 11.5 20.5 16 21C13.8 22.4 11.1 23 8.5 22.5C4 21.6 1 17.5 1 13C1 7.5 5.3 3 10.7 3C11.2 3 11.6 3 12 3Z"
                  fill="currentColor"
                />
                <path d="M19 3L19.7 5.3L22 6L19.7 6.7L19 9L18.3 6.7L16 6L18.3 5.3L19 3Z" fill="currentColor" />
              </svg>
              <p className="footer-quote-text">
                {siteConfig?.footerQuote ||
                  "In every product, the story speaks. In every detail, the craft listens."}
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom mt-5 pt-4 border-top">
          <div className="footer-bottom-grid">
            <p className="mb-0 footer-text">
              All Rights Reserved © 2026 Royal Agate
            </p>
            <a
              href="https://axesell.com"
              className="floating-designer-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="floating-content">
                <img src={`${process.env.PUBLIC_URL}/assets/axesell_logo.png`} className="floating-icon" alt="Axesell" />
              </div>
            </a>
          </div>
        </div>
      </Container>
    </footer>
    </>
  )
}

export default Footer
